// Bramble & Bean — Letterpress roastery (Kraft #3D2818 · Cream #F0E4D0 · Copper #B87333)
export const META = { brand: 'Bramble & Bean', tag: 'Roastery · Brooklyn · Single-origin only · Est. 2014', est: '2014' };
export const ROUTES = [
  { id: 'home', label: 'Roastery' },
  { id: 'menu', label: 'The menu' },
  { id: 'beans', label: 'Single-origin' },
  { id: 'visit', label: 'Visit' },
];

export const MENU = {
  Espresso: [
    { code: 'E-01', t: 'Espresso · doppio', d: '14g, 28s, glass cup', price: '$4' },
    { code: 'E-02', t: 'Cortado', d: '4 oz, demerara on the side', price: '$4.50' },
    { code: 'E-03', t: 'Flat white', d: '6 oz, microfoam to 60°C', price: '$5' },
    { code: 'E-04', t: 'Caffè latte', d: '8 oz, single shot', price: '$5.50' },
  ],
  'Pour-over': [
    { code: 'P-01', t: 'V60 · single origin', d: 'Hand-poured at 90 — 92°C', price: '$6' },
    { code: 'P-02', t: 'Chemex · for two', d: 'Slow-pour, 8 minutes', price: '$11' },
    { code: 'P-03', t: 'Cold brew', d: '14-hour steep · house bottle', price: '$5.50' },
  ],
  Bakery: [
    { code: 'B-01', t: 'Cardamom bun', d: 'House laminated, by 11am usually gone', price: '$5' },
    { code: 'B-02', t: 'Sourdough toast', d: 'Cultured butter, sea salt', price: '$5.50' },
    { code: 'B-03', t: 'Almond croissant', d: 'Frangipane filling, baked daily', price: '$5.50' },
  ],
};

export const BEANS = [
  { code: 'B-118', origin: 'Yirgacheffe, Ethiopia', producer: 'Worka Sakaro', process: 'Washed', notes: 'Bergamot · jasmine · honey', roast: 'Light', price: '$24 / 250g' },
  { code: 'B-122', origin: 'Huila, Colombia', producer: 'Finca La Mesa', process: 'Honey', notes: 'Plum · brown sugar · almond', roast: 'Medium-light', price: '$20 / 250g' },
  { code: 'B-126', origin: 'Cerrado, Brazil', producer: 'Cooperativa Pinhalense', process: 'Natural', notes: 'Chocolate · hazelnut · molasses', roast: 'Medium', price: '$18 / 250g' },
  { code: 'B-129', origin: 'Antigua, Guatemala', producer: 'Finca El Injerto', process: 'Washed', notes: 'Apricot · cane sugar · cocoa', roast: 'Medium', price: '$22 / 250g' },
];
